import Vue from 'vue'
import VueMq from 'vue-mq'
import VueLazyload from 'vue-lazyload'
import Vue2TouchEvents from 'vue2-touch-events'

// Global Components
import Asd20Button from '@asd20/ui/src/components/atoms/Asd20Button'
import ClientOnly from '@asd20/ui/src/components/utils/ClientOnly'
import Asd20Icon from '@asd20/ui/src/components/atoms/Asd20Icon'
import scrollTrack from '@asd20/ui/src/directives/scroll-track'

import App from './App.vue'
import store from './store'
import router from './router'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.component('Asd20Button', Asd20Button)
Vue.component('Asd20Icon', Asd20Icon)
Vue.component('ClientOnly', ClientOnly)

Vue.use(VueLazyload)
Vue.directive('scroll-track', scrollTrack)
Vue.use(Vue2TouchEvents)

Vue.use(VueMq, {
  breakpoints: {
    sm: 768,
    md: 1024,
    lg: 1140,
    xl: 1600,
  },
  defaultBreakpoint: 'sm',
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
